import { connect } from 'react-redux'

import { MenuItems } from '@components/chef/chefSections'

import coordinators from '@coordinators'
import presenters from '@presenters'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state) => {
  const {
    chef,
    copyMenuItemModal,
    copyMenuItemsModal,
    editMenuItemModal,
    menuConcepts,
  } = state
  const chefId = chef && chef.id
  const { mainMenuItems, sideMenuItems, otherMenuItems } = chef || {}
  let menuItems
  if (mainMenuItems && sideMenuItems && otherMenuItems) {
    menuItems = [...mainMenuItems, ...sideMenuItems, ...otherMenuItems]
  }

  return {
    chefId,
    menuConcepts,
    menuItems,
    showEditItemModal: editMenuItemModal.show,
    showCopyMenuItemModal: copyMenuItemModal.show,
    showCopyMenuItemsModal: copyMenuItemsModal.show,
  }
}

const mapDispatchToProps = () => {
  const { ChefService, RestService, UIService, SettingsService } = services
  const {
    pDefaultMenuFields,
    pStateToReduxMenuItem,
    pToMenuItemVerifications,
  } = presenters
  const {
    pResponseMenuItem,
    pResponseMenuItems,
    pSerializeLoadMenuItemsParams,
    pResponseSettings,
    pRequestBulkUpdateMenuItem,
    pRequestSettings,
    pRequestUpdateItemImages,
    pRequestUpdateMarketplaceAddOn,
    pResponseConcept,
    pResponseConcepts,
    pRequestUpdateMenuConcept,
    pRequestUpdateConceptImages,
    pRequestChefOrders,
    pResponseOrders,
  } = presenters.Api
  const {
    BulkRestoreMenuItems,
    CloseChildMenuItemModal,
    DeleteMenuItems,
    EditMenuItem,
    LoadChefMenuItems,
    LoadMenuItem,
    LoadSettings,
    NewMenuItem,
    RetryOnTimeout,
    SaveMenuItem,
    LoadMenuItemRatings,
    ShowCopyMenuItems,
    AsyncLoadConcept,
    SaveMenuConcept,
    LoadChefOrders,
    LoadMenuConcepts,
  } = coordinators

  const editMenuItem = EditMenuItem({
    ChefService,
    RestService,
    UIService,
    pResponseMenuItem,
  })
  const loadMenuItem = LoadMenuItem({
    RestService,
    pResponseMenuItem,
    HandleError,
  })
  const loadChefMenuItems = LoadChefMenuItems({
    ChefService,
    RestService,
    pResponseMenuItems,
    pSerializeLoadMenuItemsParams,
  })
  const loadMenuItemRatings = LoadMenuItemRatings({ RestService })
  const newMenuItem = NewMenuItem({
    ChefService,
    UIService,
    pDefaultMenuFields,
  })
  const deleteMenuItems = DeleteMenuItems({
    UIService,
    RestService,
  })

  const bulkRestoreMenuItems = BulkRestoreMenuItems({
    UIService,
    RestService,
    HandleError,
  })
  const loadMenuItemSettings = LoadSettings({
    RestService,
    SettingsService,
    pRequestSettings,
    pResponseSettings,
    RetryOnTimeout,
    HandleError,
  })('menuItems')
  const saveMenuItem = SaveMenuItem({
    ChefService,
    RestService,
    UIService,
    pRequestUpdateMarketplaceAddOn,
    pRequestUpdateMenuItem: pRequestBulkUpdateMenuItem,
    pRequestUpdateItemImages,
    pResponseMenuItem,
    pResponseMenuItems,
    CloseChildMenuItemModal,
    EditMenuItem,
    HandleError,
    pStateToReduxMenuItem,
    pSerializeLoadMenuItemsParams,
  })
  const showCopyMenuItem = (menuItemId) =>
    UIService.EditMenuItem.showCopyMenuItem(menuItemId)

  const copyMenuItems = ShowCopyMenuItems({ UIService })

  const asyncLoadConcept = AsyncLoadConcept({
    RestService,
    pResponseConcept,
    HandleError,
  })

  const saveMenuConcept = SaveMenuConcept({
    ChefService,
    RestService,
    UIService,
    pRequestUpdateMenuConcept,
    pResponseConcepts,
    pRequestUpdateConceptImages,
    HandleError,
  })

  const loadChefOrders = LoadChefOrders({
    RestService,
    pRequestChefOrders,
    pResponseOrders,
    HandleError,
  })

  const loadConcepts = LoadMenuConcepts({
    ChefService,
    RestService,
    pResponseConcepts,
    HandleError,
  })

  return {
    bulkRestoreMenuItems,
    deleteMenuItems,
    editMenuItem,
    loadChefMenuItems,
    loadMenuItemRatings,
    loadMenuItem,
    loadMenuItemSettings,
    newMenuItem,
    pToMenuItemVerifications,
    showCopyMenuItem,
    saveMenuItem,
    copyMenuItems,
    asyncLoadConcept,
    saveMenuConcept,
    loadChefOrders,
    loadConcepts,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItems)
